import { Component, type ErrorInfo, type ReactNode } from 'react'
import ErrorPage from 'layout/ErrorPage'

class BasicErrorBoundary extends Component<
  { children: ReactNode; name: string },
  {
    hasError: boolean
  }
> {
  state: { hasError: boolean } = { hasError: false }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('PLM application error', {
      error,
      errorBoundaryName: this.props.name,
      componentStack: errorInfo.componentStack,
    })
  }

  render() {
    return this.state.hasError ? <ErrorPage /> : this.props.children
  }
}

export default BasicErrorBoundary
